import React from "react";

const HeroBD = () => {
  return (
    <section className="pb-5 pt-2 text-center sm:pb-6">
      <h1 className="st-font-display text-[52px] leading-[1.04] text-[#131313] sm:text-[60px] lg:text-[72px]">
        <span className="font-semibold not-italic">Yeay! </span>
        <span className="font-normal not-italic">Selamat </span>
        <span className="italic">Datang</span>
      </h1>

      <p className="st-font-body mx-auto mt-4 max-w-3xl text-[18px] leading-[1.4] text-[#2E2E2E] sm:text-[20px] lg:text-[24px]">
        Tinggal <span className="font-bold">satu langkah</span> lagi sebelum mulai. Yuk,
        <span className="font-bold"> lengkapi</span> dulu data dirimu biar kami bisa kasih
        <span className="font-bold"> hasil</span> yang paling <span className="font-bold">cocok</span> buat kamu!
      </p>
    </section>
  );
};

export default HeroBD;
